var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content-container"},[_c('h2',{staticClass:"py-4"},[_vm._v("Список пациентов")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.patients,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }